import React from "react";
import { getYear, getDay, getMonth } from "../utils/util";
import {
  FacebookShareButton,
  LineShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TwitterIcon,
  FacebookIcon,
  WhatsappIcon,
  LineIcon,
  TelegramIcon,
  LinkedinIcon,
} from "react-share";

const WebinarBody = ({ param }) => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-8">
          <div dangerouslySetInnerHTML={{ __html: param.DESC_EVENT }}></div>
        </div>
        <div className="col-lg-4">
          <img src={param.FULL_PATH_IMAGE} className="img-fluid mb-4" alt="" />
          <div className="post-infos d-flex">
            <span className="info posted-by">
              Posted by :
              <span className="post-author font-weight-semibold text-color-dark">
                Admin pro-visioner
              </span>
            </span>
          </div>
          <span className="month-year font-weight-light">
            Date : {getDay(param.DATE_EVENT)} {getMonth(param.DATE_EVENT)}{" "}
            {getYear(param.DATE_EVENT)}
          </span>
          <div className="post-infos d-flex">
            <span className="info posted-by">
              Tags :
              <span className="post-author font-weight-semibold text-color-dark">
                {param.TAG}
              </span>
            </span>
          </div>
          <div style={{ marginBottom: "10px" }}>
            Share: &nbsp;
            <TwitterShareButton url={window.location.href}>
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
            &nbsp;
            <FacebookShareButton url={window.location.href}>
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            &nbsp;
            <LinkedinShareButton url={window.location.href}>
              <LinkedinIcon size={32} round={true} />
            </LinkedinShareButton>
            &nbsp;
            <WhatsappShareButton url={window.location.href}>
              <WhatsappIcon size={32} round={true} />
            </WhatsappShareButton>
            &nbsp;
            <LineShareButton url={window.location.href}>
              <LineIcon size={32} round={true} />
            </LineShareButton>
            &nbsp;
            <TelegramShareButton url={window.location.href}>
              <TelegramIcon size={32} round={true} />
            </TelegramShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebinarBody;
